import React from 'react';
import { Link } from '@curi/react';
import NewsletterForm from '../../forms/NewsletterForm/index';

import './Footer.css';

export default function Footer() {
  const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

  return (
    <>
      <div className="small-12 cell foos-newsletter">
        <h1>Sign up to receive updates on codeSpark!</h1>
        <NewsletterForm />
      </div>
      <div className="footer-container">
        <div className="footer-content grid-x grid-margin-x align-spaced">
          <div className="card-container small-12 medium-3">
            <div className="contact-card grid-x grid-padding-x align-center">
              <div className="logo-footer small-12">
                <a href="/" rel="noopener noreferrer">
                  <img src={`${imgURL}/global/logo/codespark-by-begin-white.png`} alt="codeSpark" />
                </a>
              </div>
              <p className="content-blurb small-12">Preparing kids everywhere with the skills they’ll need for the world of tomorrow.</p>
              <div>
                <ul className="social-links small-12">
                  <li>
                    <a href="https://www.facebook.com/codesparkinc/" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/facebook_footer_icon.svg`} alt="Facebook social link" />
                    </a>
                  </li>
                  <li>
                    <a href="http://twitter.com/codesparkapp" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/twitter_footer_icon.svg`} alt="Twitter social link" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/codesparkapp/" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/instagram_footer_icon.svg`} alt="Instagram social link" />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="app-store-badges">
                <a
                  className="apple"
                  href="https://itunes.apple.com/us/app/codespark-academy-foos-coding/id923441570?mt=8"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-event-category="app-download"
                  data-event-action="foos site global footer"
                  data-event-label="ios"
                >
                  <img src={`${imgURL}/global/icons/apple_store_button.svg`} alt="Apple app store link" />
                </a>
                <a
                  className="google"
                  href="http://play.google.com/store/apps/details?id=org.codespark.thefoos&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-event-category="app-download"
                  data-event-action="foos site global footer"
                  data-event-label="android-google"
                >
                  <img src={`${imgURL}/global/icons/google_store_button.svg`} alt="Google play link" />
                </a>
              </div>
            </div>
            <div className="chrome-store-badge">
              <a
                href="https://apps.chrome/getit/4c1f7ecb-61d5-445d-8458-43241c00a970"
                target="_blank"
                rel="noopener noreferrer"
                data-event-category="app-download"
                data-event-action="foos site global footer"
                data-event-label="chromebook"
              >
                <img src={`${imgURL}/global/icons/chromebook_store_button.svg`} alt="Add to Chromebook"/>
              </a>
            </div>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>FOR PARENTS</h5>
              <li>
                <Link to="HowItWorks">How it works</Link>
              </li>
              <li>
                <a href="https://homerlearning-codespark.kustomer.help/?themeId=6298f569784e442bb588ae2a&status=published">
                  FAQ
                </a>
              </li>
              <li>
                <a href={process.env.REACT_APP_ACCOUNTS_BASE_URL}>Start a Free Trial</a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_ACCOUNTS_BASE_URL}/gift`} target="_blank" rel="noopener noreferrer">
                  Buy a Gift
                </a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_ACCOUNTS_BASE_URL}/promo`}>Redeem a Gift</a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_ACCOUNTS_BASE_URL}/login`}>Login</a>
              </li>
            </ul>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>FOR EDUCATORS</h5>
              <li>
                <Link to="Educators">Educator Resources</Link>
              </li>
              <li>
                <Link to="HourOfCode">Hour of Code</Link>
              </li>
              <li>
                <a href={process.env.REACT_APP_DASHBOARD_BASE_URL} target="_blank" rel="noopener noreferrer">
                  Educator Login
                </a>
              </li>
              <li>
                <a href="https://teach.codespark.com/courses/codespark-ignite">Professional Development</a>
              </li>
            </ul>
            <ul>
              <h5>PARTNERS</h5>
              <li>
                <Link to="GirlScouts">Girl Scouts</Link>
              </li>
              <li>
                <a href="https://codeninjas.codespark.com/login" target="_blank" rel="noopener noreferrer">
                  Code Ninjas
                </a>
              </li>
              <li>
                <a href="https://app.impact.com/campaign-promo-signup/codeSpark1614190230174.brand?execution=e12s1" target="_blank" rel="noopener noreferrer">
                  Affiliates
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>CODESPARK</h5>
              <li>
                <Link to="About">About Us</Link>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_BLOG_BASE_URL}/posts/codespark-academy-award-winning-coding-app`} target="_blank" rel="noopener noreferrer">
                  Awards
                </a>
              </li>
              <li>
                <Link to="Press">Press</Link>
              </li>
              <li>
                <Link to="Contact">Contact Us</Link>
              </li>
              <li>
                <a href="https://shop.codespark.com/" target="_blank" rel="noopener noreferrer">
                  The Foo Store
                </a>
              </li>
              <li>
                <a href={process.env.REACT_APP_BLOG_BASE_URL} target="_blank" rel="noopener noreferrer">
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-crumb grid-x grid-padding-x">
          <div className="copyright small-12 medium-3">
            <b>&copy; codeSpark {new Date().getFullYear()}</b>
          </div>
          <div className="terms small-12 medium-1">
            <Link to="Terms">Terms</Link>
          </div>
          <div className="privacy small-12 medium-1">
            <Link to="Privacy">Privacy</Link>
          </div>
          <div className="small-12 medium-3">
            <Link to="Privacy" hash="ccpa">
              Do Not Sell My Personal Information
            </Link>
          </div>
          <div className="compliance small-12 medium-4">Updated for CCPA compliance effective Jan 1, 2020</div>
        </div>
      </div>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/global/Footer/index.js